const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://taraanaya-prod-production.up.railway.app';

// Sync one-time gate flags to MongoDB so they survive app uninstall/reinstall
export const syncGateFlagsToServer = async (userId) => {
  if (!userId) return;
  const pastViewed = localStorage.getItem('past_story_viewed') === 'true';
  const freeUsed = localStorage.getItem('free_story_used') === 'true';
  if (!pastViewed && !freeUsed) return;
  try {
    await fetch(`${BACKEND_URL}/api/auth/gate-flags`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userId,
        past_story_viewed: pastViewed,
        free_story_used: freeUsed
      })
    });
  } catch (_) { /* non-fatal background sync */ }
};

// Restore gate flags from server response (after login/session restore)
export const restoreGateFlagsFromServer = (gateFlags) => {
  if (!gateFlags) return;
  if (gateFlags.past_story_viewed) {
    localStorage.setItem('past_story_viewed', 'true');
  }
  if (gateFlags.free_story_used) {
    localStorage.setItem('free_story_used', 'true');
  }
};
